module.exports = __webpack_public_path__ + "static/img/charityFoundation.99c02ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/charityFoundation.jpg
// module id = 6/JR
// module chunks = 0